var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.research)?_c('Markdown',{staticClass:"mt-4",attrs:{"title":_vm.research.title,"content":_vm.research.md}}):_c('S404')
}
var staticRenderFns = []

export { render, staticRenderFns }